<template>
  <div>
  <v-data-table :headers="headers" :items="newTableList" hide-actions class="c-insurance-plan simple-table">
    <template slot="items" slot-scope="props">
       <tr>
          <td>
            <p>{{props.item.planName}}</p>
          </td>
          <td>
            <p>{{props.item.jobName}}</p>
          </td>
          <td>
            <p>{{props.item.unitPrice}}</p>
          </td>
          <td>
            <p>{{props.item.applicantCount}}</p>
          </td>
          <td>
            <p>{{props.item.totalPrice}}</p>
          </td>
        </tr>
    </template>
  </v-data-table>
  <v-layout class="price-footer">
      <div class="people">人数汇总：{{totalObj.count}}</div>
      <div class="price">总保费：{{totalObj.price}}</div>
  </v-layout>
  </div>
</template>

<script>
import selectPlanList from '@/assets/js/planList'
import selectPlanListB from '@/assets/js/planListB'
import planListB from "../../assets/js/planListB";
export default {
  props: {
    code: {
      type: String,
      default: ""
    },
    // planId: Number,
    employees: {
      type: Array,
      default() {
        return [];
      }
    },
    effectDuration: {
      type: Number,
      default: 12
    }
  },
  data() {
    return {
      totalObj:{
        price:0,
        count:0
      },
      newTableList:[],
      // 产品方案只有一个方案D了。原来是选择的，从 props 接受，现在只有一个了直接定义在这里
      selectPlanList:selectPlanList,
      headers: [
        {
          text: "所选计划",
          value: "planName",
          sortable: false
        },
        {
          text: "职业类别",
          value: "jobName",
          sortable: false,
        },
        {
          text: "计划单价",
          value: "unitPrice",
          sortable: false,
        },
        {
          text: "投保人数",
          value: "applicantCount",
          sortable: false,
        },
        {
          text: "总金额",
          value: "totalPrice",
          sortable: false,
        }
      ],
      postUrl:"/app/api/heshunbao/employeeTrialPrice",
    };
  },
  computed: {
    product() {
      return this.$store.getters.getProduct(this.code);
    },
  },
  watch: {
    // 人数变了，重新计算保费
    employees() {
      this.getPrice();
    },
    // 保障期限变了，重新计算保费
    effectDuration() {
      this.getPrice();
    },
    'totalObj.price'(val) {
      if(val){
        this.$emit("input", val);
      }else{
        this.$emit("input", 0);
      }
    },
  },
  created() {
  },
  mounted() {
      if (this.code === '2017'){
          this.postUrl = "/app/api/heshunbao/b/employeeTrialPrice"
          this.selectPlanList = planListB
      }
  },
  methods: {
    getPrice() {
      let planlist = []
      this.employees.map(item=>{
        // const {accMoney,accDrug} = this.selectPlanList.find(val=>val.value.id == item.category.planId).value
        // this.selectPlanList.map(val=>{
        //   if(val.value.id == item.category.planId){
        //     let planObj = {
        //       1:val.value.accMoney,
        //       2:val.value.accDrug,
        //       3:val.value.accHospital,
        //     }
        //     planProductList = planObj
        //   }
        // })
        // planProductList = {
        //   1:accMoney,
        //   2:accDrug,
        //   3:18000,
        // }
        let obj = {
          jobLevel:item.category.level,
          planId:item.category.planId,
          planName:item.category.planName,
          // planProductList:planProductList
        }
        planlist.push(obj)
      })
      const entity = {
        productId: parseInt(this.code),
        insurancePeriod: this.effectDuration >= 12?1:this.effectDuration,
        insurancePeriodUnit: this.effectDuration >= 12?3:2,
        planList: planlist
      };
      // 发起请求
      this.$axios
        .post(this.postUrl, entity)
        .then(res => {
          this.totalObj.price=res.data.totalPrice
          this.totalObj.count=res.data.count
          this.newTableList = res.data.showPlanJobList
          let arr = res.data.planJobList
          arr.forEach(r=>{
            const {accMoney,accDrug} = this.selectPlanList.find(val=>val.value.id == r.planId).value
            r.planProductTermsList = [
              {
                productTermsId:1,
                coverage:accMoney
              },
              {
                productTermsId:2,
                coverage:accDrug
              },
              {
                productTermsId:3,
                coverage:100
              }
            ]
          })
          this.$emit("update:planList",arr);
        })
        .catch(err => {
          console.log("err", err);
        });
    },
  }
};
</script>

<style lang="scss">
.c-insurance-plan {
  width: 745px;
  .thead-th {
    width: 195px;
    .thead-input {
      width: 3em;
      display: inline-block;
    }
  }
  // 框架样式覆盖
  .v-text-field.v-text-field--solo .v-input__control {
    flex: none;
    width: 120px;
    min-height: 30px;
  }
  .v-select {
    justify-content: center;
    font-size: inherit;
  }
}
.price{
  margin-left: 20px;
}
.price-footer{
  margin-top: 30px;
  justify-content: right;
}
</style>


